import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Loading } from "./Loading";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ isAllowed, children, redirecTo = "/Login" }) => {
  //Redux
  const { auth, userData } = useSelector(state => state.configAuth);
  const [isloading, setLoading] = useState(false);
  var roleUser = [];
  var validateRoleUser = false;

  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 100);
  }, []);

// const Roles = isAllowed === "External" ? ["Simple User"] : ["Admin","User Enovate","Moderator"] ;

  const SelectRoles = (condition) => {
    switch (condition) {
      case 'External':
        return ["Simple User"];
      case 'Internal':
        return ["Admin", "User Enovate", "Moderator"];
      case 'Bound':
        return ["Admin", "User Enovate", "Moderator","Simple User"];
      default:
        return 'Dont Rol';
    }
  };
  const Roles = SelectRoles(isAllowed);
  if (!isloading) {
    return <div><Loading/></div>;
  }

  if (roleUser !== null) {
    roleUser = userData?.role;
    if (!Array.isArray(roleUser)) {
      roleUser = [roleUser];
    }
    validateRoleUser = roleUser.every((element) => Roles.includes(element));
  }

  if (auth && validateRoleUser) {
    return children ? children : <Outlet />;
  }

  if (auth && !validateRoleUser) {
    alert("I don't have permission fot this view");
    if (
      roleUser.includes("Admin") ||
      roleUser.includes("User Enovate") ||
      roleUser.includes("Moderator")
    ) {
      return <Navigate to={"/Admin"} />;
    } else {
      return <Navigate to={"/"} />;
    }
  }

  if (!auth) {
    alert("please login to continue");
    return <Navigate to={redirecTo} />;
  }
};

export default ProtectedRoute;
